module.exports = __webpack_public_path__ + "img/wellways.ad53ba4.png";